var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content account-book" },
    [
      _c("div", { staticClass: "details-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "span",
            {
              staticStyle: {
                position: "absolute",
                right: "10px",
                "margin-top": "5px",
                "z-index": "9999"
              }
            },
            [
              _c(
                "el-link",
                {
                  attrs: { type: _vm.lbAccountType },
                  on: { click: _vm.selectAccountSetHandler }
                },
                [_vm._v(_vm._s(_vm.lbAccount))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "before-leave": _vm.handleBeforeLeave,
                    lazy: true,
                    type: "card"
                  },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_SubsidiaryLedger"),
                        name: "flowChartMultiCurrency"
                      }
                    },
                    [
                      _c("finacial-flow-chart-view2-multi-currency", {
                        ref: "flowChartMultiCurrency",
                        attrs: {
                          "account-set": _vm.accountSet,
                          "used-currency-collection": _vm.usedCurrencyCollection
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_StatementOfBalance"),
                        lazy: true,
                        name: "dbViewMultiCurrency"
                      }
                    },
                    [
                      _c("dealings-balance-view2-multi-currency", {
                        ref: "dbViewMultiCurrency",
                        attrs: {
                          "account-set": _vm.accountSet,
                          "used-currency-collection": _vm.usedCurrencyCollection
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_AccountsReconciliation"),
                        lazy: true,
                        name: "dcaViewMultiCurrency"
                      }
                    },
                    [
                      _c("dealings-check-accounts-view2-multi-currency", {
                        ref: "dcaViewMultiCurrency",
                        attrs: {
                          "account-set": _vm.accountSet,
                          "used-currency-collection": _vm.usedCurrencyCollection
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_GeneralLedger"),
                        lazy: true,
                        name: "glViewMultiCurrency"
                      }
                    },
                    [
                      _c("general-ledger-view2-multi-currency", {
                        ref: "glViewMultiCurrency",
                        attrs: {
                          "account-set": _vm.accountSet,
                          "used-currency-collection": _vm.usedCurrencyCollection
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BalancesOfAccountTitle"),
                        lazy: true,
                        name: "atViewMultiCurrency"
                      }
                    },
                    [
                      _c("account-title-balance-view2-multi-currency", {
                        ref: "atViewMultiCurrency",
                        attrs: {
                          "account-set": _vm.accountSet,
                          "used-currency-collection": _vm.usedCurrencyCollection
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_SubsidiaryLedgerDay"),
                        lazy: true,
                        name: "flowChartMultiCurrencyDay"
                      }
                    },
                    [
                      _c("finacial-flow-chart-view2-multi-currency-day", {
                        ref: "flowChartMultiCurrencyDay",
                        attrs: {
                          "account-set": _vm.accountSet,
                          "used-currency-collection": _vm.usedCurrencyCollection
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("account-set-popup", {
        ref: "refAccountSetPopup",
        attrs: {
          mode: _vm.accountSetPopup.mode,
          visible: _vm.accountSetPopup.visible,
          "load-accounting-document-type-flag": true,
          "load-mapping-departments-flag": true,
          "load-mapping-staffs-flag": true,
          "load-accounting-documents-rule-flag": false,
          "load-used-currency-flag": true,
          "sort-fiscal-period-desc": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.accountSetPopup, "visible", $event)
          },
          cancel: function() {
            return (_vm.accountSetPopup.visible = false)
          },
          select: _vm.accountSetSelectHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }